import type { AxiosInstance } from 'axios';
import axios, { HttpStatusCode } from 'axios';

import { env } from '../../config/env.client';

export class RestClient {
  private readonly instance: AxiosInstance;
  constructor() {
    this.instance = axios.create({
      baseURL: `${env.GATSBY_PUBLIC_API_BASE_URL}/v1`,
      timeout: Number(env.GATSBY_PUBLIC_API_TIMEOUT),
    });
    this.interceptors();
  }

  private interceptors() {
    this.instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (typeof window !== 'undefined') {
          if (!error.response) {
            window.dispatchEvent(new CustomEvent('app:offline'));
            return Promise.reject(error);
          }

          if (error.response.status === HttpStatusCode.Unauthorized) {
            window.dispatchEvent(
              new CustomEvent('app:no-authetication', {
                detail: error.response.status,
              }),
            );
          }

          if (error.response.status === HttpStatusCode.Forbidden) {
            window.dispatchEvent(
              new CustomEvent('app:forbidden', {
                detail: error.response.status,
              }),
            );
          }

          if (error.response.status >= HttpStatusCode.InternalServerError) {
            window.dispatchEvent(
              new CustomEvent('app:server-error', {
                detail: error.response.status,
              }),
            );
          }
        }

        return Promise.reject(error);
      },
    );
  }

  protected async post<T>(url: string, body?: T, config = {}) {
    return this.instance.post(url, body, {
      withCredentials: true,
      ...config,
    });
  }

  protected async get(url: string, params = {}, config = {}) {
    return this.instance.get(url, {
      params: { ...params },
      withCredentials: true,
      ...config,
    });
  }

  protected async put<T>(url: string, body?: T, config = {}) {
    return this.instance.put(url, body, {
      withCredentials: true,
      ...config,
    });
  }

  protected async delete(url: string, params = {}, config = {}) {
    return this.instance.delete(url, {
      params: { ...params },
      withCredentials: true,
      ...config,
    });
  }

  protected async patch<T>(url: string, body?: T, config = {}) {
    return this.instance.patch(url, body, {
      withCredentials: true,
      ...config,
    });
  }
}
